



































































import Vue, {PropType} from 'vue';
import { ProjectDef } from '@/types/Project';

export default Vue.extend({
    name: 'project-list',
    props: {
        username: { type: String, required: true },
        projects: { type: Array as PropType<ProjectDef[]>, required: true },
    },
});
